var map = {
	"./telaAzulRoyal (1).png": 1881,
	"./telaAzulRoyal (2).png": 4560,
	"./telaAzulRoyal (3).png": 7488,
	"./telaAzulRoyal (4).png": 9770,
	"./telaAzulRoyal (5).png": 9561,
	"./telaAzulRoyal (6).png": 4909,
	"./telaAzulRoyal (7).png": 6253,
	"./telaAzulRoyal (8).png": 7457,
	"./telaAzulRoyal (9).png": 8762
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4495;